import React from 'react'
import { Widget } from '@typeform/embed-react'
import { getLoggedUser, getWorkspaceName } from '../../utils/session/sessionStorage'
import ControlledModal from '../../components/modals/ControlledModal'
import { useCloseModal, useModalData } from '../../components/modals/ModalsContext'
import useMarkAsViewedRequest from './_request/markAsViewedRequest'
import { setLastCampaignView } from './_helpers/campaign'

const TypeFormModal = props => {
  const user = getLoggedUser()
  const workspace = getWorkspaceName()
  const { campaignId } = useModalData() || {}
  const closeModal = useCloseModal()
  const [markAsViewed] = useMarkAsViewedRequest()

  if (!campaignId) return <></>

  setLastCampaignView(campaignId)

  return (
    <ControlledModal height="50rem" width="50rem" noPadding disableHistory={true} publicModal={false} {...props}>
      <Widget
        id={campaignId}
        style={{ width: '100%', height: '95%' }}
        hidden={{ name: user?.name, email: user?.email, workspace: workspace, profile: user?.contract?.profile?.name }}
        onSubmit={() => {
          markAsViewed(campaignId, user?.id)
          // TODO: Fix component being re-rendered, then we can skip this step and let user close manually after reading the ending message
          closeModal()
        }}
        enableSandbox={false}
      />
    </ControlledModal>
  )
}

export default TypeFormModal
